module.exports = __webpack_public_path__ + "img/nested-list-example.3d3c3940.png";